import { storeToRefs } from 'pinia'
import { onBeforeMount, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useLocaleStore, useUserStore } from '@/stores/system'
import { useBuffer } from './buffer'
import { useLocaleManager } from 'composables/useLocaleManager.ts'

export const useAppSetup = () => {
	const router = useRouter()
	const route = useRoute()

	const { isLoggedIn } = storeToRefs(useUserStore())
	const localeManager = useLocaleManager()
	const localeStore = useLocaleStore()

	onBeforeMount(() => {
		localeManager.setLocale(localeStore.locale)
	})
	watch(
		isLoggedIn,
		(value) => {
			if (value) {
				if (!isLoggedIn.value) {
					return
				}

				//flareAddContext();
				const currentRoute = route

				if (currentRoute.name !== 'login') {
					return
				}

				if (
					typeof currentRoute.query.redirect === 'string' ||
					currentRoute.query.redirect === undefined
				) {
					router
						.push({
							path: currentRoute.query.redirect || 'dashboard',
						})
						.catch(() => {})
				}
			}
		},
		{ immediate: true }
	)
}
